import AutofacturacionInfoStore from './AutofacturacionInfoStore';
import AutofacturacionListStore from './AutofacturacionListStore';
import AutofacturacionUploadStore from './AutofacturacionUploadStore';
import AutofacturacionTicketListStore from './AutofacturacionTicketListStore';
import AutofacturacionUploadStoreConverter from './AutofacturacionUploadStoreConverter';

const AutofacturacionStore = {
  info: AutofacturacionInfoStore,
  archivos: AutofacturacionListStore,
  upload: AutofacturacionUploadStore,
  tickets: AutofacturacionTicketListStore,
  converter: AutofacturacionUploadStoreConverter,
};

export default AutofacturacionStore;
